var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReveal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.608 11.94c0-2.5 1.978-4.528 4.415-4.528 2.438 0 4.415 2.028 4.415 4.528 0 2.5-1.977 4.527-4.415 4.527-2.437 0-4.415-2.028-4.415-4.527Zm7.293 0c0-1.624-1.288-2.951-2.878-2.951-1.583 0-2.877 1.327-2.877 2.95 0 1.624 1.294 2.952 2.877 2.952 1.584 0 2.878-1.328 2.878-2.951Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.97 18.839h.06c6.918 0 11.445-6.151 11.636-6.414L24 11.96l-.335-.472C23.475 11.218 18.948 5 12.03 5h-.06C5.053 5 .527 11.226.336 11.488L0 11.96l.335.465c.19.263 4.717 6.414 11.636 6.414Zm-.006-1.577c-5.085 0-8.856-3.934-10.02-5.309 1.157-1.388 4.935-5.37 10.02-5.37h.06c5.085 0 8.856 3.982 10.019 5.37-1.163 1.375-4.934 5.31-10.02 5.31h-.059Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReveal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Reveal.db6635edc8a3758b2d7c81767b610447.svg";